import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  poBoxValidationError: {
    description: 'Error message when P.O. Box is used as a pickup address',
    defaultMessage: 'P.O. Boxes cannot be used for pickup addresses.',
    id: '/0L625',
  },
  fullNameValidationError: {
    description: 'Error message when user has input an invalid full name',
    defaultMessage: 'Requires 2 names at least 2 characters each.',
    id: 'cfmLd9',
  },
  companyLengthValidationError: {
    description: 'Error message when company name is too short or too long',
    defaultMessage: 'Company Name must be between 2 and 50 characters.',
    id: 'pI/PjU',
  },
  phoneNumberValidationError: {
    description: 'Error message when phone number is too short or too long',
    defaultMessage: 'Phone Number must be between 10 and 15 digits long.',
    id: 'P/Qcmp',
  },
  phoneNumberValidationCharError: {
    description: 'Error message when phone number uses invalid characters',
    defaultMessage: 'Use numbers, spaces, parentheses, + and - symbols only.',
    id: 'A8PeqL',
  },
});
